import { Box } from '@mui/material';
import * as React from 'react';

import { AsyncContent } from '~/components/AsyncContent';
import { UnitSelect } from '~/components/UnitSelect';

import { IndicatorCategoryTab } from '../../models';

import { IndicatorsContainer } from './components/IndicatorsContainer';
import { NavigationBar } from './components/NavigationBar';
import { useContent } from './useContent';
import { useSxStyles } from './useStyles';

export interface Props {
  containerWidth: number;
}

export const Content: React.FC<Props> = ({ containerWidth }) => {
  const sxStyles = useSxStyles();

  const {
    loading,
    failedToLoad,
    indicatorDictionary,
    unitList,
    selectedUnitId,
    changeSelectedUnit,
  } = useContent();

  const [selectedCategoryTab, setSelectedCategoryTab] = React.useState(
    IndicatorCategoryTab.ALL,
  );
  const handleCategoryChange = (_: React.ChangeEvent<{}>, newValue: number) => {
    setSelectedCategoryTab(newValue);
  };

  return (
    <AsyncContent
      isLoading={loading}
      failedToLoad={failedToLoad}
      customSxStyles={{ errorMessage: sxStyles.errorMessage }}
    >
      <NavigationBar
        selectedCategory={selectedCategoryTab}
        handleCategoryChange={handleCategoryChange}
        indicatorList={Object.keys(indicatorDictionary || {})}
      />
      <Box sx={sxStyles.root}>
        {selectedUnitId && (
          <UnitSelect
            selectOnChange={changeSelectedUnit}
            selectDefaultValue={selectedUnitId ? selectedUnitId : 1}
            menuList={unitList}
          />
        )}
        {indicatorDictionary && selectedUnitId && (
          <IndicatorsContainer
            selectedCategoryTab={selectedCategoryTab}
            indicatorDictionary={indicatorDictionary}
            unitId={selectedUnitId}
            containerWidth={containerWidth}
          />
        )}
      </Box>
    </AsyncContent>
  );
};
